// import React from 'react';
// import { Dialog, DialogContent, IconButton, Box, useTheme } from '@mui/material';
// import { Close } from '@mui/icons-material';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import CustomTextField from 'components/Fileds/CustomTextFiled';
// import CustomTypography from 'components/Fileds/CustomTypography';
// import CustomButton from 'components/Fileds/CustomButton';
// import "./style.css";

// const CategorySchema = Yup.object().shape({
//   name: Yup.string().required('Category Name is required'),
// });

// const FoodCategoriesModal = ({ open, onClose, initialData, onSubmit, loading }) => {
//   const theme = useTheme();
//   const isEdit = Boolean(initialData);
//   const title = isEdit ? 'Edit Food Category' : 'Add Food Category';

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="xs"
//       fullWidth
//       className="food-categoires-dialog"
//       PaperProps={{ sx: { borderRadius: '20px', padding: '10px', color: 'black' } }}
//     >
//       <Box className='d-flex align-items-center justify-content-center' sx={{ m: 0, p: 2 }}>
//         <CustomTypography
//           variant="h5"
//           label={title}
//           sx={{ fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main, mb: 0 }}
//         />
//         <IconButton aria-label="close" onClick={onClose} className='close-icon-container'>
//           <Close />
//         </IconButton>
//       </Box>

//       <Formik
//         initialValues={{ name: initialData?.name || '' }}
//         validationSchema={CategorySchema}
//         onSubmit={onSubmit}
//       >
//         {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
//           <Form>
//             <DialogContent className='food-categories-content'>
            //   <CustomTypography
            //     label="Category Name"
            //     sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
            //   />
//               <CustomTextField
//                 name="name"
//                 value={values.name}
//                 onChange={handleChange}
//                 onBlur={handleBlur}
//                 fullWidth
//                 placeholder="Enter Food Category"
//                 error={touched.name && Boolean(errors.name)}
//                 helperText={touched.name && errors.name}
//               />
//             </DialogContent>

//             <Box className='d-flex align-items-center justify-content-center' sx={{ p: 2 }}>
//               <CustomButton
//                 type='submit'
//                 fullWidth
//                 disabled={!values.name.trim() || isSubmitting || loading}
//                 sx={{ borderRadius: "10px", width: "220px", py: 2.1, height: '45px' }}
//               >
//                 {isEdit ? 'Update' : 'Save'}
//               </CustomButton>
//             </Box>
//           </Form>
//         )}
//       </Formik>
//     </Dialog>
//   );
// };

// export default FoodCategoriesModal;




/* FoodCategoriesModal.js */
import React from 'react';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { useTheme } from '@mui/material';

const CategorySchema = Yup.object().shape({
  name: Yup.string().required('Category Name is required'),
});

const FoodCategoriesModal = ({ open, onClose, initialData, onSubmit, loading }) => {
  const isEdit = Boolean(initialData);
  const title = isEdit ? 'Edit Food Category' : 'Add New Category';
  const theme = useTheme();
  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title={title}
      initialValues={{ name: initialData?.name || '' }}
      validationSchema={CategorySchema}
      onSubmit={onSubmit}
      submitLabel={isEdit ? 'Update' : 'Save'}
      loading={loading}
      requiredFields={[ 'name' ]}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <>
          <CustomTypography
              label="Category Name"
              sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
          />
          <CustomTextField
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            placeholder="Enter Food Category"
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
          />
        </>
      )}
    </GenericDialog>
  );
};

export default FoodCategoriesModal;
